import { StihlFileDTO } from "./stihl-file-dto";

export class AdvExpenseDashBoard {
  Campaigns: DashboardCampaign[];
  CampaignTypeCharts: DashboardCampaign[];
  MediaCharts: DashboardCampaign[];
  FormatCharts: DashboardCampaign[];
  SupportCharts: DashboardCampaign[];
  TotalExpenses: number;
  ApprovedExpenses: number;
  PendingInvoices: number;
  ApprovedInvoices: number;
  TotalAmount: string;
}

export class DashboardCampaign {
  Name: string;
  Amount: number;
  Percentage: number;
}

export class SelectListParams {
  IdElement: number[];
  IdDistributor: number[];
  districtCode: number[]

  constructor({ idElement = [], IdDistrib = [], districtCode = [] }) {
    this.IdElement = idElement;
    this.IdDistributor = IdDistrib;
    this.districtCode = districtCode;
  }


}

export class AdvExpenseFilters {
  IdDistributor: number | null;
  DistrictCode: string[];
  IdCampaignType: number | null;
  IdMedia: number | null;
  IdFormat: number | null;
  IdSupport: number | null;
  IdStatus: number | null;
  InitDate: string | null;
  EndDate: string | null;

  constructor({ idDistrib = null, districtCode = [], idCampType = null,
    idMedia = null, idFormat = null, idSupport = null,
    initDate = null, endDate = null }) {

    this.IdDistributor = idDistrib;
    this.DistrictCode = districtCode;
    this.IdCampaignType = idCampType;
    this.IdMedia = idMedia;
    this.IdFormat = idFormat;
    this.IdSupport = idSupport;
    this.InitDate = initDate;
    this.EndDate = endDate;

  }


}


export class SelectListDistrictManager {
  id: number;
  text: string;
  districts: number[];
}

export class StihlAdvExpenseDTO {
  IdAdvExpense: string;
  IdAdvExpenseInt: number;
  IdDistributor: number;
  CodDistributor: number;
  Distributor: string;
  RegionCode: number;
  DistrictManager: string;
  IdStatus: number;
  Status: string;
  IdCampaignType: number;
  CampaignType: string;
  IdMedia: number;
  Media: string;
  IdFormat: number;
  Format: string;
  Support: string;
  IdCreativePieceType: number;
  CreativePieceType: string;
  IdCampaign: number | null;
  CustomCampaign: string;
  Campaign: string;
  ExpectedAmount: number;
  ExpectedAmountRead: string;
  InitDate: string;
  EndDate: string;
  InvoiceCode: string;
  InvoiceDate: string | null;
  InvoiceAmount: number | null;
  InvoiceAmountRead: string;
  InvoiceBonus: string;
  InvoiceConcept: string;
  CreativePieceFile: StihlFileDTO | null;
  OriginalInvoiceFile: StihlFileDTO | null;
  SupplierInvoiceFile: StihlFileDTO | null;
  SupportJustifyingFile: StihlFileDTO | null;
  CreationDate: string;
  ActualComment: string;
  BonusAmount: string;
  BonusPercentage: number | null;
  Percentage: number | null;
  BudgetYear: number | null;
  EmailUser: string;
  Comments: ExpenseComments[] = [];
}

export class ExpenseComments {
  Status: string;
  User: string;
  Comment: string;
  Date: string;
}

export class StihlAdvExpensePostDTO {
  IdDistributor: number;
  CodDistributor: number;
  RegionCode: number;
  IdStatus: number;
  IdCampaignType: number;
  IdMedia: number;
  IdFormat: number;
  Support: string;
  IdCreativePieceType: number;
  IdCampaign: number;
  CustomCampaign: string | null;
  ExpectedAmount: number;
  ExpectedAmountRead: string;
  InitDate: string;
  EndDate: string;
  InvoiceCode: string | null;
  InvoiceDate: string | null;
  InvoiceAmount: number | null;
  InvoiceBonus: string | null;
  InvoiceConcept: string | null;
  CreativePieceFile: File | null;
  OriginalInvoiceFile: File | null;
  SupplierInvoiceFile: File | null;
  SupportJustifyingFile: File | null;
  ActualComment: string;
  BonusAmount: string | null;
  BonusPercentage: number | null;
  Percentage: number | null;
  BudgetYear: number | null;
}

export class StihlAdvExpenseLogDTO {
  IdAdvExpenseLog: string;
  IdAdvExpense: number;
  IdStatus: number;
  Comment: string;
  CreationDate: string;

  constructor(idExpense, idStatus, comment) {

    this.IdAdvExpense = idExpense;
    this.IdStatus = idStatus;
    this.Comment = comment;

  }
}

export interface AdvExpenseStatistics {
  TOTAL: string;
  MANAGER: ZoneManager[];
}

export interface ZoneManager {
  NAME: string;
  AMOUNT: number;
  AMOUNT_FORMAT: string;
  ORDER: number;
}

export class AdvExpenseBudgetResult {
  TotalBudget: string;
  Free: string | null;
  TotalSpentConf: string;
  TotalSpentProv: string;
  RemainConf: string;
  RemainConfString: string;
  TotalExtraSpentConf: string | null;
  SpentConfPercent: number | null;
  SpentProvPercent: number | null;
  ProvGraph: AdvExpenseBudgetGraph[];
  ConfGraph: AdvExpenseBudgetGraph[];
}



export class AdvExpenseBudgetGraph {
  name: string;
  y: number;
  color: string | null;
}

export class AdvExpensSendAlert {
  IdDistributor: number;
  IdExpense: number;
  Email: string;
  BudgetYear: number | null;
  CreationDate: string;
}